import _wrapAsyncGenerator from "/app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _awaitAsyncGenerator from "/app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _asyncGeneratorDelegate from "/app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate.js";
import _asyncIterator from "/app/node_modules/@babel/runtime/helpers/esm/asyncIterator.js";
export const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
export const readBytes = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator(function* (iterable, chunkSize) {
    var _iteratorAbruptCompletion = false;
    var _didIteratorError = false;
    var _iteratorError;
    try {
      for (var _iterator = _asyncIterator(readStream(iterable)), _step; _iteratorAbruptCompletion = !(_step = yield _awaitAsyncGenerator(_iterator.next())).done; _iteratorAbruptCompletion = false) {
        const chunk = _step.value;
        {
          yield* _asyncGeneratorDelegate(_asyncIterator(streamChunk(chunk, chunkSize)), _awaitAsyncGenerator);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion && _iterator.return != null) {
          yield _awaitAsyncGenerator(_iterator.return());
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
  return function readBytes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
const readStream = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator(function* (stream) {
    if (stream[Symbol.asyncIterator]) {
      yield* _asyncGeneratorDelegate(_asyncIterator(stream), _awaitAsyncGenerator);
      return;
    }
    const reader = stream.getReader();
    try {
      for (;;) {
        const {
          done,
          value
        } = yield _awaitAsyncGenerator(reader.read());
        if (done) {
          break;
        }
        yield value;
      }
    } finally {
      yield _awaitAsyncGenerator(reader.cancel());
    }
  });
  return function readStream(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = e => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const {
          done,
          value
        } = await iterator.next();
        if (done) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};